import React from 'react';
import { StringColumn, CustomColumn, NumericalColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';
import _get from 'lodash/get';
import { STATUS_COLORS, LIST_COL_NAMES as COL_NAMES, STATUS_COL_NAMES as STAT_COL } from './constants';
import { getStatusColor } from './helper';

const StatusCell = ({ value }: { value: { status: string } }) => (
	<span style={{ color: getStatusColor(value.status, STATUS_COLORS), fontWeight: 'bold' }}>{value.status}</span>
);

const RemarksCell = ({ value }: { value: string }) => (
	<span title={value} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
		{value}
	</span>
);

const safeGetNumber = (data: any, path: string, defaultValue = 0) => {
	const value = _get(data, path, defaultValue);
	if (value === null || value === undefined || value === '') {
		return defaultValue;
	}
	const num = Number(value);
	return Number.isNaN(num) ? defaultValue : num;
};

export const columnConfigs = [
	StringColumn({
		title: 'Requester Email',
		maxWidth: 250,
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.REQUESTER_EMAIL, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Description',
		maxWidth: 400,
		mapDataToValue: (data: any) => {
			return String(_get(data, COL_NAMES.DESCRIPTION, EMPTY_STRING));
		}
	}),
	CustomColumn({
		title: 'Status',
		maxWidth: 120,
		mapDataToValue: (data: any) => ({
			status: String(_get(data, COL_NAMES.STATUS, EMPTY_STRING))
		}),
		renderCell: StatusCell
	}),
	StringColumn({
		title: 'Created At',
		maxWidth: 180,
		mapDataToValue: (data: any) => {
			const date = _get(data, COL_NAMES.CREATED_AT);
			return date ? new Date(date).toLocaleString() : EMPTY_STRING;
		}
	}),
	NumericalColumn({
		title: 'Total Rows',
		mapDataToValue: (data: any) => {
			const value = safeGetNumber(data, COL_NAMES.TOTAL_ROWS);
			return value;
		}
	}),
	NumericalColumn({
		title: 'Success Count',
		mapDataToValue: (data: any) => {
			const value = safeGetNumber(data, COL_NAMES.SUCCESS_COUNT);
			return value;
		}
	}),
	NumericalColumn({
		title: 'Failure Count',
		mapDataToValue: (data: any) => {
			const value = safeGetNumber(data, COL_NAMES.FAILURE_COUNT);
			return value;
		}
	})
];

export const statusColumnConfigs = [
	StringColumn({
		title: 'User Email',
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			return String(_get(data, STAT_COL.USER_EMAIL, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Action',
		maxWidth: 100,
		mapDataToValue: (data: any) => {
			return String(_get(data, STAT_COL.ACTION, EMPTY_STRING));
		}
	}),
	CustomColumn({
		title: 'Status',
		maxWidth: 100,
		mapDataToValue: (data: any) => ({
			status: String(_get(data, STAT_COL.STATUS, EMPTY_STRING))
		}),
		renderCell: StatusCell
	}),
	StringColumn({
		title: 'Processed At',
		maxWidth: 180,
		mapDataToValue: (data: any) => {
			const date = _get(data, STAT_COL.PROCESSED_AT);
			return date ? new Date(date).toLocaleString() : '-';
		}
	}),
	CustomColumn({
		title: 'Remarks',
		maxWidth: 220,
		mapDataToValue: (data: any) => {
			return String(_get(data, STAT_COL.REMARK, '-'));
		},
		renderCell: RemarksCell
	})
];
